import { SYSTEM_EVENT_TYPE_OPTIONS } from '../Contracts/SystemEventOptions'

import type { IResourceConfig } from '@/Core/Contracts/UI'

/**
 * Системні події: стандартна колекція ядра (картка, фільтр з чіпами, налаштування
 * колонок), лише для читання — без картки запису й дій у рядку.
 * Сортування за замовчуванням задає бекенд: createdAt DESC.
 */
export const SystemEventResource: IResourceConfig = {
    key: 'Setting.SystemEvents',
    title: 'Системні події',
    restUrl: '/services/system_events',
    pageUrl: '/settings/system-events',
    fields: {
        id: {
            label: 'ID',
            type: 'number',
            /** У фільтрі: оператор (=, >, ≥, <, ≤) або діапазон від–до */
            isFilterRange: true,
        },
        type: {
            label: 'Тип події',
            type: 'status',
            options: SYSTEM_EVENT_TYPE_OPTIONS,
            isFilterMultiple: true,
            /** Бейдж без меню зміни: подія — факт, її не редагують */
            inputProps: { disabled: true },
        },
        user: {
            label: 'Користувач',
            type: 'select',
            resource: 'Setting.User',
        },
        ip: {
            label: 'IP-адреса',
            type: 'string',
        },
        description: {
            label: 'Опис',
            type: 'string',
        },
        createdAt: {
            label: 'Дата',
            type: 'datetime',
        },
        uuid: {
            label: 'UUID',
            inputProps: { disabled: true },
        },
    },
    table: {
        showColumns: ['type', 'user', 'ip', 'description', 'createdAt'],
        scroll: { x: 'max-content' },
        eventHandlers: {
            onBuildColumns: {
                /** Подвійний клік по рядку нічого не відкриває: картки запису немає */
                noRowCard: ({ tableContext }: any) => {
                    tableContext.props.onRow = () => ({})
                },
            },
            onBuildColumn: {
                setColumnWidths: ({ column }: any) => {
                    const widths: Record<string, number> = {
                        id: 60,
                        type: 210,
                        user: 220,
                        ip: 140,
                        createdAt: 150,
                    }
                    if (widths[column.dataIndex]) column.width = widths[column.dataIndex]
                },
            },
        },
    },
    filter: {
        includeFields: ['id', 'type', 'user', 'ip', 'createdAt'],
    },
    settings: {
        searchFields: ['id', 'ip', 'description'],
    },
}
